// App.js
import './App.css';
import HomePage from "./app/page";
import './styles/globals.css';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext'; // Import AuthProvider
import BlogPage from "./app/BlogPage";
import ShopPage from "./app/ShopPage";
import ProductDetail from "./app/ProductDetail";
import CartPage from "./app/CartPage";
import Register from "./app/auth/Register";
import Login from "./app/auth/Login";
import Dashboard from "./app/auth/Dashboard";
import Wishlist from "./app/auth/Wishlist";
import Orders from "./app/auth/Orders";
import Checkout from "./app/Checkout";
import OrderSuccess from "./app/OrderSuccess";
import ContactPage from "./app/ContactPage";
import FAQPage from "./app/FAQPage";
import AboutPage from "./app/AboutPage";
import PrivacyPolicy from "./app/PrivacyPolicy";
import GiftSetsPage from "./app/GiftSets";
import ForgotPasswordPage from "./app/auth/ForgotPassword";
import TermsConditions from "./app/TermsConditions";
import ReturnsPolicy from "./app/ReturnsPolicy";
import ShippingPolicy from "./app/ShippingPolicy";
import OffersPage from "./app/OffersPage";
import AccountAddresses from "./app/auth/AccountAddresses";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import ResetPassword from "./app/auth/ResetPassword";
import OrderTracking from "./components/layout/OrderTracking";
import BlogsList from "./app/AddBlog";
import AddBlog from "./app/AddBlog";
import BlogRedirect from "./app/BlogRedirect";
import BlogManagement from "./app/BlogManagement";

function App() {
    return (
        <AuthProvider> {/* Wrap everything with AuthProvider */}
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />

                    {/* Protected Routes */}
                    <Route path="/account" element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } />
                    <Route path="/account/orders" element={
                        <ProtectedRoute>
                            <Orders />
                        </ProtectedRoute>
                    } />
                    <Route path="/account/wishlist" element={
                        <ProtectedRoute>
                            <Wishlist />
                        </ProtectedRoute>
                    } />
                    <Route path="/account/addresses" element={
                        <ProtectedRoute>
                            <AccountAddresses />
                        </ProtectedRoute>
                    } />

                  {/* Public Routes */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/blog/:slug" element={<BlogPage />} />
                    <Route path="/blog/tag/:tag" element={<BlogPage />} />
                    <Route path="/shop" element={<ShopPage />} />
                    <Route path="/product/:productIdentifier" element={<ProductDetail />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/track-order" element={<OrderTracking />} />
                    <Route path="/track-order/:orderNumber" element={<OrderTracking />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/order-success" element={<OrderSuccess />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsConditions />} />
                    <Route path="/returns" element={<ReturnsPolicy />} />
                    <Route path="/shipping" element={<ShippingPolicy />} />
                    <Route path="/offers" element={<OffersPage />} />
                    <Route path="/gift-sets" element={<GiftSetsPage />} />
                    <Route path="/admin/blogs" element={<BlogsList />} />
                    <Route path="/admin/blogs/add" element={<BlogsList />} />
                    <Route path="/admin/blogs/edit/:id" element={<BlogsList />} />
                </Routes>
            </Router>
        </AuthProvider>
        // <AuthProvider>
        //     <Router>
        //         <Routes>
        //
        //             {/* ========================= */}
        //             {/* Public Blog Routes */}
        //             {/* ========================= */}
        //
        //             <Route path="/" element={<HomePage />} />
        //             <Route path="/blog" element={<BlogPage />} />
        //             <Route path="/blog/:slug" element={<BlogPage />} />
        //             <Route path="/blog/tag/:tag" element={<BlogPage />} />
        //
        //             {/* Catch All → Redirect to Blog */}
        //             <Route path="*" element={<BlogRedirect />} />
        //
        //             {/* ========================= */}
        //             {/* Authentication Routes */}
        //             {/* ========================= */}
        //
        //             <Route path="/login" element={<Login />} />
        //             <Route path="/register" element={<Register />} />
        //             <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        //             <Route path="/reset-password/:token" element={<ResetPassword />} />
        //
        //             {/* ========================= */}
        //             {/* Admin Routes (Protected) */}
        //             {/* ========================= */}
        //
        //             <Route
        //                 path="/admin"
        //                 element={
        //                     <ProtectedRoute requireAdmin={true}>
        //                         <Navigate to="/admin/blogs" replace />
        //                     </ProtectedRoute>
        //                 }
        //             />
        //
        //             <Route path="/admin/blogs" element={
        //                 <ProtectedRoute requireAdmin={true}>
        //                     <BlogManagement />
        //                 </ProtectedRoute>
        //             } />
        //
        //             <Route
        //                 path="/admin/blogs/add"
        //                 element={
        //                     <ProtectedRoute requireAdmin={true}>
        //                         <AddBlog />
        //                     </ProtectedRoute>
        //                 }
        //             />
        //
        //             <Route
        //                 path="/admin/blogs/edit/:id"
        //                 element={
        //                     <ProtectedRoute requireAdmin={true}>
        //                         <AddBlog />
        //                     </ProtectedRoute>
        //                 }
        //             />
        //
        //             {/* ========================= */}
        //             {/* User Account Route */}
        //             {/* ========================= */}
        //
        //             <Route
        //                 path="/account"
        //                 element={
        //                     <ProtectedRoute>
        //                         <Dashboard />
        //                     </ProtectedRoute>
        //                 }
        //             />
        //
        //         </Routes>
        //     </Router>
        // </AuthProvider>
    );
}

export default App;